(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["hawk"] = factory();
	else
		root["hawk"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Logger module
 *
 * @usage
 * logger.log('We got an error', 'error')
 *
 * @param message
 * @param type - log type: error, warn, info, log, etc.
 */
module.exports.log = function (message, type) {

    type = type || 'info';

    message = '[CodeX Hawk]: ' + message;

    if ('console' in window && window.console[type]) {

        window.console[type](message);
    }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * Codex Hawk client side module
 * https://github.com/codex-team/hawk.client
 *
 * Codex Hawk - https://hawk.so
 * Codex Team - https://ifmo.su
 *
 * @license MIT (c) CodeX 2017
 */
module.exports = function () {

    'use strict';

    var config = __webpack_require__(2),
        websocket = __webpack_require__(4),
        logger = __webpack_require__(0),
        ws = null,
        token = void 0;

    /**
     * Hawk client constructor
     * @param  {string} token_      personal token
     * @param  {string} host        optional: client catcher hostname
     * @param  {Number} port        optional: client catcher port
     * @param  {string} path        hawk catcher route
     * @param  {Boolean} secure     pass FALSE to disable secure connection
     */
    var init = function init(token_, host, port, path, secure) {

        config.socket.host = host || config.socket.host;
        config.socket.port = port || config.socket.port;
        config.socket.path = path || config.socket.path;
        config.socket.secure = secure !== undefined ? secure : config.socket.secure;

        if (!token_) {

            logger.log('Please, pass your verification token for Hawk error tracker. You can get it on hawk.so', 'warn');
            return;
        }

        token = token_;

        var socket = config.socket;

        socket.onmessage = socketHandlers.message;
        socket.onclose = socketHandlers.close;

        ws = websocket(socket);

        window.addEventListener('error', errorHandler);
    };

    var socketHandlers = {

        message: function message(data) {

            var message = void 0,
                type = void 0;

            try {

                data = JSON.parse(data.data);
                type = data.type;
                message = data.message;
            } catch (e) {

                message = data.data;
                type = 'info';
            }

            logger.log('Message from server: ' + message, type);
        },

        close: function close() {

            logger.log('Connection lost. Errors won\'t be save. Please, refresh the page', 'warn');
        }

    };

    /**
     * Error event handler.
     * Get error params and send to Hawk server
     *
     * @param ErrorEvent
     */
    var errorHandler = function errorHandler(ErrorEvent) {

        var error = {
            token: token,
            message: ErrorEvent.message,
            error_location: {
                file: ErrorEvent.filename,
                line: ErrorEvent.lineno,
                col: ErrorEvent.colno
            },
            location: {
                url: window.location.href,
                origin: window.location.origin,
                host: window.location.hostname,
                path: window.location.pathname,
                port: window.location.port
            },
            stack: ErrorEvent.error.stack || ErrorEvent.error.stacktrace,
            time: Date.now(),
            navigator: {
                ua: window.navigator.userAgent,
                frame: {
                    width: window.innerWidth,
                    height: window.innerHeight
                }
            }
        };

        ws.send(error);
    };

    var test = function test() {

        var fakeEvent = {
            message: 'Hawk client catcher test',
            filename: 'hawk.js',
            lineno: 0,
            colno: 0,
            error: {
                stack: 'hawk.js'
            }
        };

        errorHandler(fakeEvent);
    };

    return {
        init: init,
        test: test
    };
}();

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

    socket: {
        host: 'hawk.so',
        path: 'catcher/client',
        port: 8070,
        secure: true
    }

};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Native websocket module
 * Open new websocket connection using native WebSocket object
 *
 * @usage
 * var ws = new websocket({
 *  host: 'localhost',
 *  path: 'socket',
 *  port: 80000,
 *  onmessage: messageHandler
 * })
 *
 * @param {Object} options
 *
 * Server properties
 * @param {String} options.host - WebSocket server host
 * @param {String} options.path - WebSocket server path
 * @param {Number} options.port - WebSocket server port
 * @param {Boolean} options.secure - if True, uses wss protocol, else ws
 *
 * Events handlers
 * @param {Function} options.onopen - fires when connection have been opened
 * @param {Function} options.onmessage - fires when message from server received
 * @param {Function} options.onclose - fires when connection have been closed
 *
 * @returns {{send: send}}
 */
module.exports = function (options) {

    var ws = null,
        logger = __webpack_require__(0);

    var STATES = {
        CONNECTING: 0,
        OPEN: 1,
        CLOSING: 2,
        CLOSED: 3
    };

    /**
     * Open new websocket connection
     * Returns promise, resolved if connection was opened and rejected on error
     *
     * @returns {Promise}
     */
    var init = function init() {

        return new Promise(function (resolve, reject) {

            var protocol = 'ws' + (options.secure ? 's' : '') + '://',
                host = options.host || 'localhost',
                path = options.path ? '/' + options.path : '',
                port = options.port ? ':' + options.port : '',
                url = protocol + host + port + path;

            ws = new WebSocket(url);

            if (typeof options.onmessage === 'function') {

                ws.onmessage = options.onmessage;
            }

            ws.onclose = function (e) {

                if (typeof options.onclose === 'function') {

                    options.onclose.call(this, e);
                }

                reject();
            };

            ws.onopen = function (e) {

                if (typeof options.onopen === 'function') {

                    options.onopen.call(this, e);
                }

                resolve();
            };
        });
    };

    /**
     * Try to open new websocket connection.
     * Returns promise, resolved if reconnect was successful, rejected otherwise
     *
     * @param attempts - number of reconnect attempts. 1 by default
     * @returns {Promise}
     */
    var reconnect = function reconnect() {
        var attempts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;


        return new Promise(function (resolve, reject) {

            init().then(function () {

                logger.log('Successfully reconnect to socket server', 'info');
                resolve();
            }, function () {

                if (attempts > 0) {

                    reconnect(attempts - 1).then(resolve, reject);
                } else {

                    logger.log('Can\'t reconnect to socket server', 'warn');
                    reject();
                }
            }).catch(function (e) {

                logger.log('Error while reconnecting to socket server', 'error');
            });
        });
    };

    /**
     * Send data to WebSocket server in JSON format
     * @param data
     */
    var send = function send(data) {

        if (ws === null) {

            return;
        }

        data = JSON.stringify(data);

        if (ws.readyState !== STATES.OPEN) {

            reconnect().then(function () {

                ws.send(data);
            }, function () {

                logger.log('Can\'t send your data', 'warn');
            });
        } else {

            ws.send(data);
        }
    };

    init().catch(function (e) {

        logger.log('Error while opening socket connection', 'error');
    });

    return {
        send: send
    };
};

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// hawk.js